import { ApplicationsTable } from './ApplicationsTable/ApplicationsTable';
import { ApplicationsTableStateProvider } from './ApplicationsTable/ApplicationsTableState.context';
import { DashboardHeader } from './DashboardHeader/DashboardHeader';

export const Dashboard = () => {
  return (
    <ApplicationsTableStateProvider>
      <DashboardHeader />
      <ApplicationsTable />
    </ApplicationsTableStateProvider>
  );
};
